import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const Pill = ({ label, href }) => {
    const cls =
        "group inline-flex items-center gap-3 rounded-full bg-[#0B1220] py-2 pl-6 pr-2 text-xs font-bold uppercase tracking-[0.12em] text-white transition-transform duration-300 hover:scale-[1.03]";
    const inner = (
        <>
            {label}
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-transform duration-300 group-hover:rotate-45">
                <ArrowUpRight className="h-4 w-4" />
            </span>
        </>
    );
    return href ? (
        <a href={href} className={cls} data-testid={`cta-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            {inner}
        </a>
    ) : (
        <button type="button" className={cls} data-testid={`cta-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            {inner}
        </button>
    );
};

export default function Cta() {
    return (
        <section
            className="relative overflow-hidden bg-white"
            style={{
                background:
                    "radial-gradient(circle at 12% 20%, rgba(0,229,255,0.10) 0%, transparent 45%), radial-gradient(circle at 90% 85%, rgba(168,85,247,0.07) 0%, transparent 45%), radial-gradient(circle at 55% 110%, rgba(0,102,255,0.05) 0%, transparent 50%), #ffffff",
            }}
            data-testid="cta-section"
            aria-labelledby="cta-heading"
        >
            <div className="mx-auto flex max-w-6xl flex-col gap-10 px-6 py-24 sm:py-32 lg:flex-row lg:items-center lg:justify-between">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    <span
                        className="inline-flex items-center gap-2 rounded-full border border-[#0F172A]/10 bg-white px-4 py-1.5 shadow-sm"
                        data-testid="cta-eyebrow"
                    >
                        <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF]" />
                        <span className="font-mono-brand text-[10px] uppercase tracking-[0.3em] text-[#475569] sm:text-xs">
                            Ready to get started
                        </span>
                    </span>
                    <h2
                        id="cta-heading"
                        className="mt-6 font-display text-4xl font-bold leading-[1.12] tracking-tight text-[#0F172A] sm:text-5xl"
                        data-testid="cta-heading"
                    >
                        Ready to run smarter
                        <br />
                        <span className="text-brand-gradient">with AI?</span>
                    </h2>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: EASE, delay: 0.15 }}
                    className="flex max-w-md flex-col items-start gap-8"
                >
                    <p className="text-base leading-relaxed text-[#64748B]" data-testid="cta-intro">
                        See how TedOps AI connects your teams, automates workflows and helps you
                        make better operational decisions — from first enquiry to final invoice.
                    </p>
                    <div className="flex flex-wrap gap-4">
                        <Pill label="Book a Demo" href="mailto:enquires@tedopsai.com?subject=Book%20a%20TedOps%20AI%20demo" />
                        <Pill label="See the Platform" />
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
